import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/chats/$conversationId',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/chats',
      search: { conversationId: params.conversationId },
    })
  },
})
